import { statusApi } from '@/axios.config';
import { StatusType } from '@/vuex/modules/status.lib';
import { mockAdapter } from '@/mocks/axiosMockAdapter.config';

export const state = {
  status: {
    message: '',
    msp_id: '',
    status: '',
  },
};

export const actions = {
  getUserStatus({ commit }) {
    const url = `uimessage`;

    mockAdapter(statusApi, 'get', url, 'getUiMessage', 200);

    return statusApi
      .get(url)
      .then(res => {
        commit('updateStatus', res.data);

        // commit('updateStatus', statusMock);
      })
      .catch(err => {
        throw err;
      });
  },
};

export const mutations = {
  updateStatus(state, data) {
    if (data['wave']) {
      data['wave']['status'] = StatusType(data['wave']['status']);
      state.status = data['wave'];
    }
  },

  reset(state) {
    state.status = {
      message: '',
      msp_id: '',
      status: '',
    };
  },
};

export const getters = {
  currentStatus(state, getters, rootState) {
    const statusData = state.status;

    /**
     * 一時対応 ↓↓ここから↓↓
     */
    // const mpsDataTemporary = rootState['mspId'];
    // // 一時対応(NTTD)
    // if (mpsDataTemporary === 'MSP-5b6a504c2abf5') {
    //   // 対象CompanyID
    //   const company_ids = ['PLdKRY6G', 'QKFDAODg', 'WvThAYVC'];
    //
    //   if (company_ids.includes(rootState['companyId'])) {
    //     const temporary = {
    //       status: 'danger',
    //       message:
    //         'レポート機能に問題があり、一時的に非表示にさせていただいております。下記メンテナンス時に復旧作業を行う予定です。ご迷惑をおかけし大変申し訳ございません。<br />システムメンテナンス期間：2019年12月27日18:00 ~ 2020年1月3日10:00 <br /><a href="http://help.alphaus.cloud/ja/articles/3538762-" target="_blank">発生事象の詳細</a>',
    //       active: true,
    //     };
    //
    //     return temporary;
    //   } else {
    //     statusData['active'] = true;
    //     return statusData;
    //   }
    //
    //   // 一時対応(GMO)
    // } else if (mpsDataTemporary === 'MSP-5c906f5bbe951c') {
    //   // 対象CompanyID
    //   const company_ids = ['L1ECNAjO5m', 'a3xNWTg9FfFK'];
    //
    //   if (company_ids.includes(rootState['companyId'])) {
    //     const temporary = {
    //       status: 'danger',
    //       message:
    //         'レポート機能に問題があり、一時的に非表示にさせていただいております。下記メンテナンス時に復旧作業を行う予定です。ご迷惑をおかけし大変申し訳ございません。<br />システムメンテナンス期間：2019年12月27日18:00 ~ 2020年1月3日10:00 <br /><a href="http://help.alphaus.cloud/ja/articles/3538762-" target="_blank">発生事象の詳細</a>',
    //       active: true,
    //     };
    //
    //     return temporary;
    //   } else {
    //     statusData['active'] = true;
    //     return statusData;
    //   }
    // } else {
    /**
     * ↑↑ここまで↑↑
     */
    statusData['active'] = false;
    // Case: massage is undefined
    if (!statusData['message']) {
      statusData['active'] = false;
    } else {
      // MSP IDが一致するかのチェック
      // 一致しない場合はactive: false
      if (Object.keys(statusData['msp_id']).length === 0) {
        // Case: msp_id === {}
        statusData['active'] = true;
      } else {
        const mpsData = state.status['msp_id'][rootState['mspId']];
        if (mpsData) {
          // Messageがある場合のみactive = true
          if (statusData['message']) {
            const companyId = rootState['companyId'];
            // Company IDが[]の場合
            if (mpsData['company_id'].length === 0) {
              statusData['active'] = true;
            }
            // Company IDが存在設定されている場合
            if (mpsData['company_id'].find(v => v === companyId)) {
              statusData['active'] = true;
            }
          }
        }
      }
    }

    return statusData;
    // }
  },
};
